var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernment83(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.07 53.6 106.39 26.96 182.71 53.6 30.07 53.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.31,
    y1: 65.84,
    x2: 171.19,
    y2: 65.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.31,
    y1: 160.88,
    x2: 171.19,
    y2: 160.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.79,
    y: 79.52,
    width: 20.16,
    height: 66.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.19,
    y: 79.52,
    width: 20.16,
    height: 66.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.59,
    y: 79.52,
    width: 20.16,
    height: 66.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.99,
    y: 79.52,
    width: 20.16,
    height: 66.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.35,
    y: 172.4,
    width: 150.48,
    height: 10.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment83);
export default __webpack_public_path__ + "static/media/GOVERNMENT_83.ec07de6ce8daa3e11047559368daf970.svg";
export { ForwardRef as ReactComponent };